import { useState, useEffect } from 'react';

const CACHE_KEY = 'vehicles_cache';
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const useVehicleCache = () => {
  const getCachedVehicles = () => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (!cached) return null;
      
      const { data, timestamp } = JSON.parse(cached);
      const now = Date.now();
      
      // Check if cache is still valid
      if (now - timestamp < CACHE_DURATION) {
        return data;
      }
      
      // Cache expired, remove it
      localStorage.removeItem(CACHE_KEY);
      return null;
    } catch (error) {
      console.error('Error reading cache:', error);
      return null;
    }
  };
  
  const setCachedVehicles = (vehicles) => {
    try {
      const cacheData = {
        data: vehicles,
        timestamp: Date.now()
      };
      localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    } catch (error) {
      console.error('Error setting cache:', error);
    }
  };
  
  const clearCache = () => {
    localStorage.removeItem(CACHE_KEY);
  };
  
  return { getCachedVehicles, setCachedVehicles, clearCache };
};
